/* becky&lolo - review strip for Judge.me Cards Carousel blocks.
   Judge.me still chooses which reviews appear (block settings in the theme
   editor). This script takes those reviews, hides Judge.me's slider and shows
   them in a native swipe/scroll strip:
   - reviews with photos first, then verified, the rest shuffled each visit
   - "Read more" on long reviews, customer photos as thumbnails
   - a quiet "Verified buyer" tick next to the name on order-matched reviews
   Review text is inserted with textContent only, never as HTML. */
(function () {
  'use strict';

  var STAR = '<svg viewBox="0 0 20 20" aria-hidden="true"><path d="M10 1.6l2.6 5.3 5.8.8-4.2 4.1 1 5.8L10 14.9l-5.2 2.7 1-5.8L1.6 7.7l5.8-.8z"/></svg>';
  var ARROW = '<svg viewBox="0 0 20 20" aria-hidden="true"><path d="M7.5 4l6 6-6 6" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var TICK = '<svg viewBox="0 0 16 16" aria-hidden="true"><circle cx="8" cy="8" r="7.25" fill="currentColor"/><path d="M4.9 8.2l2.1 2.1 4.1-4.4" fill="none" stroke="#ffffff" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var WAIT_FOR_DATA_MS = 3000;
  var GIVE_UP_MS = 15000;

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text) n.textContent = text;
    return n;
  }

  // HTML -> plain text, parsed in an inert document (nothing executes)
  function toText(html, keepParagraphs) {
    if (!html) return '';
    var doc = new DOMParser().parseFromString(String(html), 'text/html');
    if (keepParagraphs) {
      var brs = doc.body.querySelectorAll('br');
      for (var i = 0; i < brs.length; i++) brs[i].replaceWith('\n');
      var ps = doc.body.querySelectorAll('p');
      if (ps.length) {
        var parts = [];
        for (var j = 0; j < ps.length; j++) {
          var t = ps[j].textContent.trim();
          if (t) parts.push(t);
        }
        if (parts.length) return parts.join('\n');
      }
    }
    return doc.body.textContent.trim();
  }

  function pictureUrl(p, big) {
    if (!p) return '';
    if (typeof p === 'string') return p;
    return big ? (p.huge || p.original || p.compact || p.small || '') : (p.compact || p.small || p.huge || p.original || '');
  }

  function fromData(list) {
    var out = [];
    for (var i = 0; i < list.length; i++) {
      var r = list[i];
      var text = toText(r.body_html, true) || toText(r.body, false);
      if (!text) continue;
      var url = r.product_url && r.product_url !== '/' ? r.product_url : '';
      var pics = [];
      var raw = r.pictures_urls || [];
      for (var k = 0; k < raw.length && pics.length < 3; k++) {
        var thumb = pictureUrl(raw[k], false);
        if (thumb) pics.push({ thumb: thumb, full: pictureUrl(raw[k], true) || thumb });
      }
      out.push({
        text: text,
        stars: Math.max(0, Math.min(5, Math.round(Number(r.rating) || 5))),
        name: toText(r.reviewer_name, false),
        verified: !!r.verified_buyer,
        product: url ? toText(r.product_title_localized || r.product_title, false) : '',
        url: url,
        pics: pics
      });
    }
    return out;
  }

  function fromDom(widget) {
    var cards = widget.querySelectorAll('.jdgm-videos-container > .jdgm-card');
    var seen = {};
    var out = [];
    for (var i = 0; i < cards.length; i++) {
      var c = cards[i];
      if (/jdgm-clone/.test(c.className)) continue;
      var id = c.getAttribute('data-review-id') || String(i);
      if (seen[id]) continue;
      seen[id] = true;
      var textEl = c.querySelector('.jdgm-text');
      var text = textEl ? textEl.textContent.replace(/\s+/g, ' ').trim() : '';
      if (!text) continue;
      var nameEl = c.querySelector('.jdgm-reviewer-name');
      var link = c.querySelector('.jdgm-product-name a');
      var href = link ? link.getAttribute('href') : '';
      out.push({
        text: text,
        stars: c.querySelectorAll('.jdgm-star.jdgm--on').length || 5,
        name: nameEl ? nameEl.textContent.trim() : '',
        verified: !!c.querySelector('.jdgm-reviewer-verified-icon'),
        product: link && href && href !== '/' ? link.textContent.trim() : '',
        url: href && href !== '/' ? href : '',
        pics: []
      });
    }
    return out;
  }

  // photo reviews first, then verified, everything else shuffled so each visit gets a fresh mix
  function order(list) {
    var scored = list.map(function (r) {
      return { r: r, score: (r.pics.length ? 2 : 0) + (r.verified ? 1 : 0), rnd: Math.random() };
    });
    scored.sort(function (a, b) { return b.score - a.score || a.rnd - b.rnd; });
    var out = scored.map(function (s) { return s.r; });
    // very long reviews don't lead the strip: move any in the first 4 slots back to slot 6
    var LONG = 450, LEAD = 4, SLOT = 5;
    var moved = [];
    for (var i = Math.min(LEAD, out.length) - 1; i >= 0; i--) {
      if (out[i].text.length > LONG) moved.unshift(out.splice(i, 1)[0]);
    }
    if (moved.length) {
      var at = Math.min(SLOT - moved.length + 1, out.length);
      Array.prototype.splice.apply(out, [Math.max(at, 0), 0].concat(moved));
    }
    return out;
  }

  function build(widget, reviews) {
    var root = el('div', 'bl-rv');
    root.setAttribute('role', 'region');
    root.setAttribute('aria-label', 'Customer reviews');

    var track = el('ul', 'bl-rv__track');
    track.setAttribute('tabindex', '0');

    reviews.forEach(function (r, idx) {
      var li = el('li', 'bl-rv__card');
      var stars = el('div', 'bl-rv__stars');
      stars.setAttribute('role', 'img');
      stars.setAttribute('aria-label', r.stars + ' out of 5 stars');
      for (var s = 0; s < 5; s++) {
        var sp = el('span', s < r.stars ? 'bl-rv__star' : 'bl-rv__star bl-rv__star--off');
        sp.innerHTML = STAR;
        stars.appendChild(sp);
      }
      li.appendChild(stars);

      var body = el('div', 'bl-rv__body');
      var text = el('p', 'bl-rv__text', r.text);
      text.id = 'bl-rv-' + Math.random().toString(36).slice(2, 8) + '-' + idx;
      body.appendChild(text);
      var more = el('button', 'bl-rv__more', 'Read more');
      more.type = 'button';
      more.hidden = true;
      more.setAttribute('aria-expanded', 'false');
      more.setAttribute('aria-controls', text.id);
      more.addEventListener('click', function () {
        var open = li.classList.toggle('is-open');
        more.textContent = open ? 'Show less' : 'Read more';
        more.setAttribute('aria-expanded', open ? 'true' : 'false');
        root.classList.toggle('bl-rv--open', !!track.querySelector('.bl-rv__card.is-open'));
      });
      body.appendChild(more);
      li.appendChild(body);

      if (r.pics.length) {
        var pics = el('div', 'bl-rv__pics');
        r.pics.forEach(function (p, n) {
          var a = el('a', 'bl-rv__pic');
          a.href = p.full;
          a.target = '_blank';
          a.rel = 'noopener';
          a.setAttribute('aria-label', 'Open customer photo ' + (n + 1));
          var img = el('img');
          img.src = p.thumb;
          img.alt = 'Customer photo';
          img.loading = 'lazy';
          img.decoding = 'async';
          a.appendChild(img);
          pics.appendChild(a);
        });
        li.appendChild(pics);
      }

      var foot = el('div', 'bl-rv__foot');
      var who = el('p', 'bl-rv__name', r.name || 'Anonymous');
      if (r.verified) {
        var v = el('span', 'bl-rv__verified');
        v.innerHTML = TICK;
        v.appendChild(document.createTextNode('Verified buyer'));
        who.appendChild(v);
      }
      foot.appendChild(who);
      if (r.product) {
        var a2 = el('a', 'bl-rv__product', r.product);
        a2.href = r.url;
        foot.appendChild(a2);
      }
      li.appendChild(foot);
      track.appendChild(li);
    });

    var prev = el('button', 'bl-rv__nav bl-rv__nav--prev');
    prev.type = 'button';
    prev.setAttribute('aria-label', 'Previous reviews');
    prev.innerHTML = ARROW;
    var next = el('button', 'bl-rv__nav bl-rv__nav--next');
    next.type = 'button';
    next.setAttribute('aria-label', 'Next reviews');
    next.innerHTML = ARROW;

    var dots = el('div', 'bl-rv__dots');
    dots.setAttribute('aria-hidden', 'true');
    reviews.forEach(function () { dots.appendChild(el('span', 'bl-rv__dot')); });

    root.appendChild(prev);
    root.appendChild(track);
    root.appendChild(next);
    root.appendChild(dots);

    function step() {
      var card = track.querySelector('.bl-rv__card');
      var gap = parseFloat(getComputedStyle(track).columnGap) || 16;
      return card ? card.getBoundingClientRect().width + gap : track.clientWidth;
    }
    function perView() {
      return Math.max(1, Math.round(track.clientWidth / step()));
    }
    prev.addEventListener('click', function () {
      track.scrollBy({ left: -step() * perView(), behavior: 'smooth' });
    });
    next.addEventListener('click', function () {
      track.scrollBy({ left: step() * perView(), behavior: 'smooth' });
    });

    // show "Read more" only where the text is actually cut off
    function measure() {
      var cards = track.children;
      for (var i = 0; i < cards.length; i++) {
        var c = cards[i];
        if (c.classList.contains('is-open')) continue;
        var t = c.querySelector('.bl-rv__text');
        var m = c.querySelector('.bl-rv__more');
        m.hidden = !(t.scrollHeight > t.clientHeight + 2);
      }
    }

    function update() {
      var max = track.scrollWidth - track.clientWidth;
      root.classList.toggle('bl-rv--static', max <= 4);
      prev.disabled = track.scrollLeft <= 4;
      next.disabled = track.scrollLeft >= max - 4;
      var first = Math.round(track.scrollLeft / step());
      var last = Math.min(reviews.length - 1, first + perView() - 1);
      if (track.scrollLeft >= max - 4) { last = reviews.length - 1; first = Math.max(0, last - perView() + 1); }
      var d = dots.children;
      for (var i = 0; i < d.length; i++) d[i].classList.toggle('is-active', i >= first && i <= last);
    }

    var pending = null;
    function schedule() {
      if (pending) return;
      pending = setTimeout(function () { pending = null; update(); }, 60);
    }
    var resizeTimer = null;
    track.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () { measure(); update(); }, 150);
    });

    var header = widget.querySelector('.jdgm-header');
    if (header && header.nextSibling) widget.insertBefore(root, header.nextSibling);
    else widget.appendChild(root);
    widget.setAttribute('data-bl-rv', 'done');

    measure();
    update();
    setTimeout(function () { measure(); update(); }, 400);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { measure(); update(); });
  }

  var firstSeen = {};
  function scan() {
    var widgets = document.querySelectorAll('.jdgm-cards-carousel:not([data-bl-rv])');
    var now = Date.now();
    for (var i = 0; i < widgets.length; i++) {
      var w = widgets[i];
      var key = w.getAttribute('data-jdgm-block-id') || ('w' + i);
      if (!firstSeen[key]) firstSeen[key] = now;
      var data = window.jdgmCarouselMode && window.jdgmCarouselMode[key];
      var list = data && data.reviews && data.reviews.length ? fromData(data.reviews) : null;
      if (!list || !list.length) {
        if (now - firstSeen[key] < WAIT_FOR_DATA_MS) continue;
        list = fromDom(w);
      }
      if (list && list.length) build(w, order(list));
      else if (now - firstSeen[key] > GIVE_UP_MS) w.setAttribute('data-bl-rv', 'fail');
    }
    return document.querySelectorAll('.jdgm-cards-carousel:not([data-bl-rv])').length;
  }

  function start() {
    var began = Date.now();
    var timer = setInterval(function () {
      var left = scan();
      if (Date.now() - began > GIVE_UP_MS + 1000) {
        clearInterval(timer);
        var rest = document.querySelectorAll('.jdgm-cards-carousel:not([data-bl-rv])');
        for (var i = 0; i < rest.length; i++) rest[i].setAttribute('data-bl-rv', 'fail');
      } else if (!left && document.querySelector('.jdgm-cards-carousel')) {
        clearInterval(timer);
      }
    }, 250);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', function () { firstSeen = {}; start(); });
})();
